var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[(_vm.isShow)?_c('div',{ref:"breathing_lamp",staticClass:"ballBtn",style:({
      left: _vm.left + 'px',
      top: _vm.top + 'px',
      width: _vm.itemWidth + 'px',
      height: _vm.itemHeight + 'px',
      opacity: _vm.opacity,
    }),on:{"touchstart":function($event){$event.stopPropagation();return _vm.handleTouchStart.apply(null, arguments)},"touchmove":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleTouchMove($event)},"touchend":function($event){$event.stopPropagation();return _vm.handleTouchEnd.apply(null, arguments)},"click":function($event){$event.stopPropagation();return _vm.onclick()}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }